import { createContext } from "react";

const CasContext = createContext();

export default CasContext;
